export default "__VITE_ASSET__39a0e491__"